import { GLOBAL_CONSTANTS } from "../../global/constants";
import { apiBookDemo } from "../../utils/api";
import { validateBookNow } from "../../utils/validate";

const $ = window.$;

export function setUpBookDemo(params) {
  $('#booknow-modal').on('submit', function () {
    if (validateBookNow()) {
      let params = {
        "company": $('#booknow-modal .company-name input').val(),
        "contact_work_email": $('#booknow-modal .email input').val(),
        "contact_name": $('#booknow-modal .contact-name input').val(),
        "contact_phone": $('#booknow-modal .phone input').val(),
      }
      const apiTime = Date.now();
      window.apiTime = apiTime;

      apiBookDemo(params
        , function (data) {
          $("#booknow-modal button.request-booknow").removeClass("loading");
          showDoneSubscribe();
          setTimeout(function () {
            $("#booknow-modal").removeClass("done");
            $("#booknow-modal").modal("hide");
          }, 3000);
        }, function (error) {
          $("#booknow-modal button.request-booknow").removeClass("loading");
          $("#booknow-modal .message").text(GLOBAL_CONSTANTS.DEFAULT_ERROR)
        }, apiTime)
    }
  })
}

function showDoneSubscribe() {
  $("#booknow-modal .modal-content").addClass("done");
}